export default __webpack_public_path__ + "static/media/category-banner-Industry.b94a7a0e.jpg";